import { Icon, IconSize, IconVariants } from "@next-platform/client-common-spicy-ui";
import { useTranslatedTag, useTranslation } from "@next-platform/client-common-core";
import { Listbox, ListboxItem } from "@nextui-org/react";
import { ReactNode, useState } from "react";

import { SpicyInput } from "@/components/customComponents";

interface ITagSuggestionMenuProps {
  bottomContent: ReactNode;
  tagOptions: string[];
  addedTags: string[];
  handleTagAddition: (tags: string[]) => void;
}

const TagSuggestionMenu = ({ bottomContent, tagOptions, addedTags = [], handleTagAddition }: ITagSuggestionMenuProps) => {
  const { getTranslatedTag } = useTranslatedTag();
  const { t } = useTranslation();
  const [stateSearchQuery, setStateSearchQuery] = useState("");
  return (
    <Listbox
      classNames={{
        base: "min-w-[300px]  bg-cardColor rounded-xl p-2",
        list: "max-h-[210px] overflow-y-auto custom-scroll",
      }}
      selectedKeys={addedTags}
      selectionMode="multiple"
      onSelectionChange={(tags) => handleTagAddition(Array.from(tags) as string[])}
      variant="flat"
      topContent={
        <SpicyInput
          placeholder={t("chatbot:tags.searchPlaceholder")}
          value={stateSearchQuery}
          onValueChange={setStateSearchQuery}
          variant="primary_underlined"
          color="transparent"
          isClearable
          onClear={() => setStateSearchQuery("")}
        />
      }
      bottomContent={bottomContent}
    >
      {Array.from(new Set(tagOptions))
        .filter((tag: string) => {
          const tagLabel = getTranslatedTag(tag);
          return tagLabel.toLowerCase().startsWith(stateSearchQuery.toLowerCase());
        })
        .map((tagOption: string) => {
          const tagLabel = getTranslatedTag(tagOption);
          return (
            <ListboxItem
              key={tagOption}
              textValue={tagOption}
              endContent={<Icon icon={addedTags?.includes(tagOption) ? IconVariants.CHECK : IconVariants.PLUS} size={IconSize.SMALL} />}
              hideSelectedIcon
            >
              {tagLabel}
            </ListboxItem>
          );
        })}
    </Listbox>
  );
};

export default TagSuggestionMenu;
